import React, { Component } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BookInformation from "./BookInformation";
import BookData from "../data/book-data";

class BookResults extends Component {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, id) {
    this.props.navigate(`/book/details/${id}`);
  }

  render() {
    let results;
    if (this.props.books.length === 0) {
      results = (
        <div className="no-search-results">
          Sorry, we couldn't find the books you are looking for.
        </div>
      );
    } else {
      results = this.props.books.map((book) => (
        <BookInformation
          key={book.id}
          data={book}
          handleClick={(e) => this.handleClick(e, book.id)}
        />
      ));
    }

    return (
      <div>
        <h1 className="search-results-title">Results:</h1>
        <div>{results}</div>
      </div>
    );
  }
}

function BookResultsFunc() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookTitle = searchParams.get("book");
  const data = new BookData().getBooksByTitle(bookTitle);

  return <BookResults title={bookTitle} books={data} navigate={navigate} />;
}

export default BookResultsFunc;
